import React from 'react';

export default function Logo({ className = "h-8" }: { className?: string }) {
  return (
    <svg 
      viewBox="0 0 529.4 118.24" 
      className={className}
      aria-label="PACER"
    >
      <path d="m0,116.07L21.71,2h42.92c26.39,0,41.92,12.53,41.92,34.4,0,25.89-21.71,43.26-54.78,43.26h-13.03l-6.85,36.41H0Zm53.78-61.46c13.03,0,20.54-6.18,20.54-15.87,0-8.02-5.34-11.86-15.03-11.86h-10.35l-5.34,27.72h10.19Z"/>
      <path d="m170.18,116.07l-2.84-24.05h-38.91l-11.69,24.05h-34.24L142.96,2h42.59l16.7,114.07h-32.07Zm-10.19-88.35l-19.37,39.75h24.05l-4.68-39.75Z"/>
      <path d="m321.98,75.99c-10.69,27.72-32.4,42.25-59.29,42.25-29.73,0-48.27-17.87-48.27-49.1C214.43,30.9,241.99,0,281.73,0c28.89,0,46.76,16.2,46.76,43.76h-32.73c-.83-11.52-7.18-17.87-17.37-17.87-17.87,0-31.23,19.21-31.23,41.92,0,16.37,7.01,24.05,18.87,24.05,10.19,0,17.7-5.51,22.88-15.87h33.07Z"/>
      <path d="m329.49,116.07L351.2,2h72.15l-4.84,25.22h-40.25l-3.67,19.37h36.91l-4.51,23.88h-36.91l-3.84,20.04h43.76l-4.84,25.55h-75.65Z"/>
      <path d="m486.47,116.07l-12.19-38.41h-12.19l-7.35,38.41h-31.9L444.56,2h43.92c25.72,0,40.92,12.19,40.92,33.57,0,16.87-9.52,30.06-25.55,36.91l14.7,43.59h-32.07Zm-8.35-63.46c12.02,0,19.04-5.68,19.04-14.7,0-7.52-5.01-11.02-14.03-11.02h-11.36l-5.01,25.72h11.36Z"/>
    </svg>
  );
}
